// Navigation des Moduls `zyklen` (eager geladen; Quelle UX §2.2–§2.10). Besitzer: Modul zyklen.
import { ArrowsClockwise } from '@phosphor-icons/react';
import { defineMeta } from '@web/registry/define';

export default defineMeta({
  key: 'zyklen',
  title: 'Review cycles',
  nav: {
    admin: [
      {
        key: 'zyklen.cycles',
        label: 'Review cycles',
        icon: ArrowsClockwise,
        path: '/performance/cycles',
        roles: ['ADM', 'HR', 'PERF', 'CL', 'CEO'],
        order: 210,
        area: 'Performance',
        readOnly: ['HR', 'CL', 'CEO'],
      },
    ],
  },
});
